var map = {
	"./abc.svg": 124,
	"./dsbn-horizontal-logo.svg": 125,
	"./dsbn-logo-w.svg": 126,
	"./dsbn-logo.svg": 127,
	"./idea-book.svg": 128,
	"./imatter-logo.svg": 129,
	"./lamp.svg": 130,
	"./owel.svg": 131,
	"./owl.svg": 132,
	"./search.svg": 133,
	"./social-facebook.svg": 134,
	"./social-instagram.svg": 135,
	"./social-twitter.svg": 136,
	"./social-youtube.svg": 137,
	"./tiger.svg": 138
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;


//////////////////
// WEBPACK FOOTER
// ./theme/_base/assets \.(svg)$
// module id = 123
// module chunks = 0 1